var React = require('react');

function BUSDIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.5904 0.050499L15.5511 3.07344L8.09593 10.5063L5.13525 7.5545L12.5904 0.050499Z","fill":"#F0B90B","stroke":"#F0B90B","key":0}),React.createElement("path",{"d":"M17.085 4.53156L20.0456 7.5545L8.09593 19.4684L5.13525 16.5166L17.085 4.53156Z","fill":"#F0B90B","stroke":"#F0B90B","key":1}),React.createElement("path",{"d":"M3.6013 9.01262L6.56197 12.0356L3.6013 14.9874L0.640625 12.0356L3.6013 9.01262Z","fill":"#F0B90B","stroke":"#F0B90B","key":2}),React.createElement("path",{"d":"M21.5796 9.01262L24.5403 12.0356L12.5906 23.9495L9.62988 20.9977L21.5796 9.01262Z","fill":"#F0B90B","stroke":"#F0B90B","key":3})]);
}

BUSDIcon.defaultProps = {"width":"20","height":"20","viewBox":"0 0 25 24","fill":"none"};

module.exports = BUSDIcon;

BUSDIcon.default = BUSDIcon;
